import React from 'react';

import { cn } from '@change/ds-utils';

import linkStickerStory from 'src/assets/starterDashboardV2/readyToShare/linkStickerStory.png';
import storyPreview from 'src/assets/starterDashboardV2/readyToShare/storyPreview.png';

import { BodyStyles, LinkStickerStyles } from './Body.styles';
import type { FacebookStoryComponentsProps } from './types';

// TODO: This is a placeholder for development. Once this is released to prod we need to only use the provided image URL.
const defaultPreviewImageUrl = storyPreview;

export function Body(props: FacebookStoryComponentsProps): React.JSX.Element {
	const { size, loading } = props;

	const styles = BodyStyles({ size });

	if (loading) {
		return <div data-testid="empty-container" className={cn('bg-icon-weak', styles)} />;
	}

	return (
		<>
			<div className="relative">
				<img src={linkStickerStory} className={LinkStickerStyles({ size })} aria-hidden alt="" />
			</div>
			<img data-testid="body-image" className={styles} src={defaultPreviewImageUrl} alt="" aria-hidden />
		</>
	);
}
